var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneMeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FF7E55"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8416 14.9633C25.2597 14.9633 21.5453 18.4833 21.5453 22.8256V35.4052C21.5453 36.2737 20.8025 36.9777 19.8861 36.9777C15.3042 36.9777 11.5898 33.4576 11.5898 29.1154C11.5898 25.2791 14.4891 22.0845 18.3244 21.3922C19.0657 15.9903 23.9396 11.8184 29.8416 11.8184C35.7436 11.8184 40.6175 15.9903 41.3588 21.3922C45.1941 22.0845 48.0933 25.2791 48.0933 29.1154C48.0933 32.9517 45.1941 36.1463 41.3588 36.8386C40.6175 42.2405 35.7436 46.4124 29.8416 46.4124C28.9252 46.4124 28.1823 45.7084 28.1823 44.84C28.1823 43.9715 28.9252 43.2675 29.8416 43.2675C34.4235 43.2675 38.1378 39.7474 38.1378 35.4052V22.8256C38.1378 18.4833 34.4235 14.9633 29.8416 14.9633ZM41.4563 33.5643C43.3897 32.9167 44.7748 31.1694 44.7748 29.1154C44.7748 27.0614 43.3897 25.314 41.4563 24.6664V33.5643ZM18.2268 24.6664C16.2935 25.314 14.9083 27.0614 14.9083 29.1154C14.9083 31.1694 16.2935 32.9167 18.2268 33.5643V24.6664Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneMeIcon);
export default __webpack_public_path__ + "static/media/PhoneMeIcon.b86f6252bc3b1b7dace328a26a0dc58c.svg";
export { ForwardRef as ReactComponent };